import { useEffect } from "react";
import { Outlet } from "react-router-dom";


export default function Header() {

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    
    
    const styles = [
      `${BASE_URL}admin/assets/css/style.css`,
      "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css",
      "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css",
      "https://cdn.jsdelivr.net/npm/bootstrap-icons/font/bootstrap-icons.css",
      "https://cdnjs.cloudflare.com/ajax/libs/morris.js/0.5.1/morris.css",
      "https://cdnjs.cloudflare.com/ajax/libs/limonte-sweetalert2/6.6.4/sweetalert2.css",
      "https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/magnific-popup.min.css",
      "https://cdnjs.cloudflare.com/ajax/libs/mediaelement/4.1.3/mediaelementplayer.min.css",
      "https://cdnjs.cloudflare.com/ajax/libs/jquery.perfect-scrollbar/0.7.0/css/perfect-scrollbar.min.css",
      "https://fonts.googleapis.com/css?family=Nunito+Sans:400,600,700",
      "https://fonts.googleapis.com/css?family=Roboto:300,400,400i,500,700",
      "https://fonts.googleapis.com/css?family=Open+Sans:300,400,600",
      "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css",
      "https://cdnjs.cloudflare.com/ajax/libs/bootstrap-daterangepicker/2.1.25/daterangepicker.min.css",
      `${BASE_URL}admin/assets/vendors/material-icons/material-icons.css`,
      `${BASE_URL}admin/assets/vendors/mono-social-icons/monosocialiconsfont.css`,
      `${BASE_URL}admin/assets/vendors/weather-icons-master/weather-icons.min.css`,
      `${BASE_URL}admin/assets/vendors/weather-icons-master/weather-icons-wind.min.css`
    ];

    const loadedStyles = styles.map(href => {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      document.head.appendChild(link);
      return link;
    });

    
    const scripts = [
      // jQuery FIRST
      "https://code.jquery.com/jquery-3.7.1.min.js",

      // jQuery plugins
      "https://cdnjs.cloudflare.com/ajax/libs/jqueryui/1.12.1/jquery-ui.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/jquery-form-validator/2.3.77/jquery.form-validator.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/jquery.perfect-scrollbar/0.7.0/js/perfect-scrollbar.jquery.js",
      "https://cdnjs.cloudflare.com/ajax/libs/jquery-sparklines/2.1.2/jquery.sparkline.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/jquery-knob/1.2.13/jquery.knob.min.js",

      // Bootstrap 3 ONLY (do NOT mix with v5)
      "https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/3.3.7/js/bootstrap.min.js",

      // Supporting libs
      "https://cdnjs.cloudflare.com/ajax/libs/modernizr/2.8.3/modernizr.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/popper.js/1.12.2/umd/popper.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/magnific-popup.js/1.1.0/jquery.magnific-popup.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/metisMenu/2.7.0/metisMenu.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/Counter-Up/1.0.0/jquery.counterup.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/waypoints/4.0.1/jquery.waypoints.min.js",

      // Charts
      "https://cdnjs.cloudflare.com/ajax/libs/Chart.js/2.4.0/Chart.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/raphael/2.2.7/raphael.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/morris.js/0.5.1/morris.min.js",
      `${BASE_URL}admin/assets/vendors/charts/utils.js`,
      `${BASE_URL}admin/assets/vendors/charts/excanvas.js`,

      // Other libs
      "https://cdnjs.cloudflare.com/ajax/libs/moment.js/2.18.1/moment.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/underscore.js/1.8.3/underscore-min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/clndr/1.4.7/clndr.min.js",
      "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.js",

      // Theme scripts (LAST)
      `${BASE_URL}admin/assets/js/material-design.js`,
      `${BASE_URL}admin/assets/js/theme.js`,
      `${BASE_URL}/admin/assets/js/custom.js`
    ];

    const loadedScripts = [];

    scripts.forEach(src => {
      const script = document.createElement("script");
      script.src = src;
      script.defer = true;
      script.async = false; // IMPORTANT: preserve order
      document.body.appendChild(script);
      loadedScripts.push(script);
    });

    
    return () => {
      loadedStyles.forEach(link => document.head.removeChild(link));
      loadedScripts.forEach(script => document.body.removeChild(script));
    };
  }, []);

  return <Outlet />;
}
 